import type { TrackedTranslation } from '@ps/web-core-intl';
import { StarsButton } from '@ps/web-shared-components';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';
import { ServerMessageHandler } from '@swf/notification';
import { useWidgetTheme } from '@swf/poker';

import { TXTCLI_OK } from './Notification.messages.json';
import styles from './Notification.scss';

interface Props {
  text: React.ReactNode | string;
  buttonText: TrackedTranslation;
}

const Notification: React.FC<Props> = () => {
  const { modal } = useDispatch<Dispatch>();
  const { text = '', buttonText = TXTCLI_OK } = useSearchParams<Props>();
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: className,
      className: styles.container,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  return (
    <div className={styles.body}>
      <p>{typeof text === 'string' ? <ServerMessageHandler message={text} /> : text}</p>
      <StarsButton
        className={styles.button}
        onClick={() => modal.close()}
        translation={buttonText}
      />
    </div>
  );
};

export default Notification;
